const ITEMS = [
  'Kassenzone', '3–6 Minuten Wartezeit', 'Mall & Vorkasse', '50 Bildschirme', 'Bedientheken', '260 × am Tag',
  'Leergut', 'Eingang & Frische', '2,0 Mio. Sichtkontakte im Monat', 'Ohne Streuverlust', '40 km Einzugsgebiet',
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-[#282C37] bg-[#16181D] py-5" data-testid="marquee" aria-hidden="true">
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#16181D] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#16181D] to-transparent" />
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((t, i) => (
          <span key={`${t}-${i < ITEMS.length ? 'a' : 'b'}`} className="flex items-center gap-10 font-display text-lg font-bold tracking-tight text-[#B6BCC8] sm:text-xl">
            {t}
            <span className="h-1.5 w-1.5 rounded-full bg-[#FF6B00]" />
          </span>
        ))}
      </div>
    </div>
  );
}
